import { Box, Grid, styled, TextField } from "@mui/material";

export const TableHead = styled(Grid)({
  borderTop: "solid 1px #000000",
  borderBottom: "solid 1px #000000",
  height: "50px",
  backgroundColor: "#F0F0F0",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  padding: "0px 5px",
  marginBottom: "10px",
});
export const SummarySection = styled(Grid)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginTop: "10px",
  marginBottom: "10px",
});
export const TableBody = styled(Grid)({
  height: "60px",
  backgroundColor: "#FFFFFF",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  padding: "0px 5px",
  marginTop: "5px",
  display: "flex",
  alignItems: "center",
});

export const Input = styled(TextField)({
  borderRadius: "4px",
  fontSize: "12px",
  marginTop: "5px",
  marginBottom: "5px",
  backgroundColor: "#F0F0F0",
});
export const UserInfo = styled(Box)({
  padding: "5px",
  display: "flex",
  backgroundColor: "#F0F0F0",
  "&:hover": {
    outlineStyle: "solid",
    outlineColor: "#257eff",
    outlineWidth: "2px",
    cursor: "pointer",
  },
});
export const UserDetails = styled(Box)({
  padding: "5px",
  backgroundColor: "#F0F0F0",
  "&:hover": {
    outlineStyle: "solid",
    outlineColor: "#257eff",
    outlineWidth: "2px",
    cursor: "pointer",
  },
});
export const ButtonBox = styled(Box)({
  marginTop: "15px",
  display: "flex",
  justifyContent: "space-evenly",
  columnGap: "20px",
});
export const SummaryInfo = styled(Box)({
  paddingLeft: "15px",
  paddingRight: "15px",
  paddingTop: "5px",
  display: "flex",
  justifyContent: "space-between",
});
export const SummaryHead = styled(Box)({
  borderTop: "solid 1px #000000",
  borderBottom: "solid 1px #000000",
  height: "50px",
  backgroundColor: "#F0F0F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "7px",
});
export const Footer = styled(Box)({
  backgroundColor: "#F0F0F0",
  marginBottom: "20px",
  border: "none",
  height: "50px",
  display: "flex",
  alignItems: "center",
});
